import React from 'react'
import {BsJustify} from 'react-icons/bs'
import scalex_ai_logo from "../images/scalex_ai_logo.png"

function Header({OpenSidebar}) {
  return (
    <header className='header'>
        <div className='menu-icon'>
            <BsJustify className='icon' onClick={OpenSidebar}/>
        </div>
          
        <div className="header-title">CognitiveUX.ai</div>
    </header>
  )
}

export default Header
